<template>
    <div class="ls-admins">

    </div>
</template>
<script>
export default {

    props: {
        value: {},

    },
    data() {
        return {
            temp: ''
        }
    },
    created() {
    },
    methods: {
    }
}
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>